export default "__VITE_ASSET__CKmUieb9__"